import { render } from "./DansukHome.vue?vue&type=template&id=5bc1cc33"
import script from "./DansukHome.vue?vue&type=script&lang=js"
export * from "./DansukHome.vue?vue&type=script&lang=js"

import "./DansukHome.vue?vue&type=style&index=0&id=5bc1cc33&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__